import React from 'react';
import ReactDOM from 'react-dom';

import Panel from "../../Panel";
import {Link} from "react-router";
import langs from "../../langs/phpIndex";
import Chart from "../Chart/Chart";
import moment from "moment";

import store from "../../../store";

import {api, cachedAPI, PANEL_TYPES, API_INFO, toString, parsePHPtime} from "../../baseFunctions";
import "./ChartMaker.css";
export default class ChartMaker extends React.Component {
	constructor(){
		super();
		this.neededAPIs = this.neededAPIs.bind(this);
		this.getNeededData = this.getNeededData.bind(this);
		this.getData = this.getData.bind(this);
		this.types = PANEL_TYPES;
		this.dataViewTable = false;
		this.printHelper = [];
		this.state = {
			data: {
				users: false,
				ra: false,
				raComments: false,
				raSumAnswers: false,
				obs: false,
				obsStats: false,
				print: false,
			},
			dataView: false,
			dataType: false,
		};
	}
	componentWillMount(){
		this.getData();
	}
	componentDidUpdate(prevProps){
		if(prevProps.interval && this.props.interval)
		{
			if((prevProps.interval.from !== this.props.interval.from || prevProps.interval.to !== this.props.interval.to) || prevProps.types.length !== this.props.types.length)
			{
				//console.log("Wonna update!");
				this.getData();
			}
		}
		//console.log("CompUpdate", prevProps, this.props);
	}

	extras = [];
	getData()
	{
		this.neededAPIs(this.props.types, true).map(async (obj, key) => 
		{
			const d = obj.value;
			let target = this.types[Object.keys(this.types).find((dat) => this.types[dat].type.indexOf(d) !== -1)];
			// let targetData = this.props.typeData ? this.props.typeData[key] : false;
			let targetData = this.props.typeData.find(d => d.type === obj.parent.key);

			let newData = {...this.state.data};
			newData[d] = false;
			this.setState({
				data: newData
			});

			let apiInfo = API_INFO[d];
			let extra = this.props.extraData ? this.props.extraData : {};
			let extraVal = targetData && targetData.extraValue ? {extraValue: targetData.extraValue} : {};
			let intervalFix = {...this.props.interval};
			
			intervalFix.from = moment(intervalFix.from * 1000).subtract(1, "day").unix();
			intervalFix.to = moment(intervalFix.to * 1000).add(1, "day").unix();
			// console.log("Hmmmm!", apiInfo, d);
			// console.log("extraVal", extraVal, obj, targetData);
			if(apiInfo.extras)
			{
				apiInfo.extras.forEach(extra => {
					extraVal[extra.name] = extra.value;
					// this.extras[extra.name] = extra.value;
				});
			}	
			
			cachedAPI("POST", {"type": apiInfo.name, "department": this.props.department, "interval": (apiInfo.getAll ? false : intervalFix), ...extra, ...extraVal}, (dat) => {
				if(!dat.error)
				{
					let newData = {...this.state.data};

					if(apiInfo.name === "getReports")
					{
						dat.data = dat.data.reports;
					}
					newData[d] = dat.data;
					this.setState({
						data: newData
					});
					if(!dat.fromCache)
					{
						store.dispatch({
							type: 'UPD_CACHE',
							data: {
								from: this.props.interval.from,
								to: this.props.interval.to,
								api: apiInfo.name,
								data: dat.data,
							}
						});
					}
				}
			}, this.props.auth, apiInfo.newAPI, this.props.cachedAPIs);
		});
	}
	neededAPIs(arr, includeParent = false)
	{
		let temp = [];
		arr.map((d) => {
			if(!this.types[d])
			{
				console.log("Not found!", d, this.types, this.props.types);
			}
			const parent = {...this.types[d], key: d};
			let target = parent.type;
			if(typeof target === "string")
			{
				if(temp.indexOf(target) === -1)
				{
					temp.push(includeParent ? {
						value: target,
						parent,
					} : target);
				}
			}else{
				target.map((targ) => {
					if(temp.indexOf(targ) === -1)
					{
						temp.push(includeParent ? {
							value: targ,
							parent,
						} : targ);
					}
				});
			}

		})
		return temp;
	}
	getNeededData(type){
		let temp = {};
		this.neededAPIs([type]).map((d) => {
			temp[d] = this.state.data[d];
		});
		return temp;
	}
	print = (key) => {
		//let target = ReactDOM.findDOMNode(this.printHelper[key]);
		let curr = this.props.types[key];
		const isProd = !(!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
		let extras = false
		// if(this.extras.sheets)
		// {
		// 	extras = this.extras.sheets.join(",");
		// }
		let newWindow = window.open('/#/print/' + curr + '/' + this.props.interval.from + '/' + this.props.interval.to + (extras ? "/" + extras : ""),'','width=' + window.outerWidth + ',height=600');

		//this.props.types
		/*let target = ReactDOM.findDOMNode(this.printHelper[key]);
		if(target.nodeName === "CANVAS")
		{
			this.setState({
				print: key
			});
		}
		setTimeout(() => {
			
			let newWindow = window.open('','','width=600,height=500');

			if(target.nodeName === "CANVAS")
			{
				let url = target.toDataURL();
				newWindow.document.write("<img src='" + url + "' style='width: 100%'/>");
				this.setState({
					print: false
				});
			}else{
				let styles = '<style>';
				styles = styles + '.table {width: 100%;max-width: 100%;margin-bottom: 20px;}';
				styles = styles + 'table {border-spacing: 0;border-collapse: collapse;}';
				styles = styles + 'table.jambo_table thead {background: rgba(52,73,94,0.94);color: #ECF0F1;}';
				styles = styles + 'table.jambo_table {border: 1px solid rgba(221,221,221,0.78);}';
				styles = styles + '';
				styles = styles + '</style>';

				newWindow.document.write(styles + target.parentNode.innerHTML);
			}

			requestAnimationFrame(() => {
				newWindow.document.close();
				newWindow.focus();
				newWindow.print();
				newWindow.close();
			});
		}, 10);
		return;
*/

		
	}
	showData = (data, table = false) => {
		if(this.dataViewTable)
		{
			this.dataViewTable.destroy();
		}
		
		console.log("SHOW DATA", table, data);
		this.setState({
			dataView: data,
			dataType: table.toLowerCase(),
		});
	}

	vars(value, data)
	{
		Object.keys(data).forEach(key => {
			const k = `%${key}%`;
			value = value.split(k).join(data[key]);
		});
		return value;
	}

	buildDataView = () => {
		let lang = langs[this.props.lang];
		if(this.state.dataView.length > 0)
		{
			let tableSettings = {
				"users": {
					"verified": false,
					"picture": false,
					"verifyData": false,
					"Rank": false,
					"rank": false,
					"deleted": false,
					"lang": false,
					"jumpableDepartments": false,
					"firmID": false,
					"role": false,
					"oldID": false,
					"fullName": false,

				},
				"obs": {
					"images": "length",
					"gps": false,
					"hash": false,
					"fields": false,
					"uID": false,
					"anon": false,
					"answerHash": false,
					"lat": false,
					"long": false,
					"oldID": false,
					"department": false,
					"extras": false,
					"createdBy": "name"
				},
			};
			let dataParser = (type, data) => {
				// console.log("Parser", type, data);
				switch(type)
				{
					case "department":
						let dep = this.props.departments[Number(data)];
						return dep ? dep : this.props.departments[0];
					break;
					case "lastActive":
					case "time":
					case "unix":
						return parsePHPtime(data / 1000);
					break;
					default:
						return data;
					break;
				}
			};
			let filters = tableSettings[this.state.dataType] !== undefined ? Object.keys(tableSettings[this.state.dataType]).filter(d => !tableSettings[this.state.dataType][d]) : [];
			// console.log("FIlters", tableSettings[this.state.dataType], this.state);
			let keys = Object.keys(this.state.dataView[0]).filter(d => filters.indexOf(d) === -1);

			return this.drawTable([
				[...keys.map(d => lang[d.toUpperCase()] ? lang[d.toUpperCase()] : d), ""],
				...this.state.dataView.map(d => {
					return [...keys.map(key => {
						let check = tableSettings[this.state.dataType];
						return dataParser(key, check !== undefined && check[key] !== undefined ? d[key][check[key]] : d[key]);
					}), <Link to={this.vars(lang['VIEW_LINKS'][this.state.dataType], {
						ID: d[keys[0]],
						CAT_ID: d.groupID,
					})
				} onClick={() => document.querySelector(".modal").click()}>{lang['SHOW']}</Link>];
				})
			], [], true, lang.DATA_OPTIONS, keys.length);
		}
		return lang.NO_DATA;
	}
	drawTable = (rows, styles = [], enableDataTable = true, options = {"retrieve": true, "iDisplayLength": 50, "order": [[ 0, "desc" ]]}, ignoreCol = false) =>
	{
		console.log("Hmm", ignoreCol, rows)
	  	return (<table className="table table-striped jambo_table bulk_action" ref={(table) => {
		  if(table && !this.props.fullPage && enableDataTable)
		  {
			this.dataViewTable = window.$(table).DataTable(options);
		  }
		}}>
		  <thead>
			<tr>
			  {
				rows[0].map((col, key) => <th key={key}>{col}</th>)
			  }
			</tr>
		  </thead>
		  <tbody>
			{rows.map((cols, key) => key !== 0 ? <tr key={key} style={styles[key - 1] ? styles[key - 1] : {}}>
			{
			  cols.map((col, key2) => <td key={key + "-" + key2}>{ignoreCol === false || ignoreCol !== key2 ? toString(col) : col}</td>)
			}
		  </tr> : null)}
		  </tbody>
		  
		</table>);
	}
	render(){
		let lang = langs[this.props.lang];
		let isLoading = this.neededAPIs(this.props.types).find((d) => {
			return this.state.data[d] === false || typeof this.state.data[d] !== "object";
		});
		
		if(!isLoading && this.props.onReady)
		{
			requestAnimationFrame(() => this.props.onReady());
		}
		
		if(this.props.hidePanels)
		{
			return (
				<div className={this.props.className}>
					{ 
						!isLoading ?
							this.props.types.map((d, key) => <Chart key={key} ref={(ref) => this.printHelper[key] = ref} fullPage={this.props.hidePanels} type={d} lang={this.props.lang} data={this.getNeededData(d)} onClick={this.props.typeData && this.props.typeData[key] && this.props.typeData[key].onClick ? this.props.typeData[key].onClick : false} from={this.props.interval ? this.props.interval.from : false} to={this.props.interval ? this.props.interval.to : false} style={this.types[d].style} reloadData={this.getData} auth={this.props.auth}/>)
						: "Loading.."
					}
				</div>
			);
		}
		return (<div className={"chartMaker " + (isLoading ? "loading" : "loaded")}>
			<div className="modal fade bs-example-modal-lg" ref="ifmgModal" tabIndex="-1" role="dialog" aria-hidden="true" style={{"display": "none"}}>
                <div className="modal-dialog modal-lg niceModal">
                  <div className="modal-content">

                    <div className="modal-header">
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
						  <span aria-hidden="true">×</span>
                      </button>
                      <h4 className="modal-title" id="myModalLabel2">{lang.DATA_VIEW}</h4>
                    </div>
                    <div className="modal-body" ref="modalBody">
                      {
						  !this.state.dataView ? 
							"Loading.."
						  : 
						  this.buildDataView()
					  }
                    </div>
                    <div className="modal-footer">
                     
                  </div>
                </div>
              </div>
			</div>
				{
					!isLoading ?
						this.props.types.map((d, key) => this.types[d].fullScreen ? 
							(<div className="panelCont" style={{width: "100%"}} key={key}>
								<Chart ref={(ref) => this.printHelper[key] = ref} showData={this.showData} type={d} lang={this.props.lang} data={this.getNeededData(d)} onClick={this.props.typeData && this.props.typeData[key] && this.props.typeData[key].onClick ? this.props.typeData[key].onClick : false} from={this.props.interval ? this.props.interval.from : false} to={this.props.interval ? this.props.interval.to : false} style={this.types[d].style} reloadData={this.getData} auth={this.props.auth}/>
								</div>) : 
							(<Panel title={lang[d]} key={"graphz" + key} size={this.types[d].panelSize} 
						customIcons={() => <li><a className="collapse-link" onClick={() => this.print(key)}>
								<i className="fa fa-print"></i>
							</a></li>}>
								<div style={this.state.print === key ? {
									"position": "absolute",
									"top": "0px",
									"left": "0px",
									"width": "100vw",
									"height": "100vh",
									"zIndex": "9999",
									"zoom": 2,
									"visibility": "hidden",
								} : {}}>
									<Chart ref={(ref) => this.printHelper[key] = ref} showData={this.showData} type={d} lang={this.props.lang} data={this.getNeededData(d)} onClick={this.props.typeData && this.props.typeData[key] && this.props.typeData[key].onClick ? this.props.typeData[key].onClick : false} from={this.props.interval ? this.props.interval.from : false} to={this.props.interval ? this.props.interval.to : false} style={this.types[d].style} reloadData={this.getData} auth={this.props.auth}/></div>
								</Panel>))
								: <div className="loader">
									Loading..
								</div>
						}
				</div>);
	}
}


// WEBPACK FOOTER //
// ./src/components/UI/ChartMaker/ChartMaker.js